export default class OrderCtrl {
    constructor($filter, SideMenu, SweetAlert, Template) {
        SideMenu.setActive('template');

        this._translator = $filter('translate');

        this.templateRepo = Template;
        this.alerter = SweetAlert;

        this.file = false;
        this.contactEmail = "";
    }

    orderUpload(file, contactEmail) {
        this.templateRepo.uploadOrder(file, contactEmail).then(() => {
            this.alerter.swal({
                title: this._translator('TEMPLATE:ORDER:PROCESSING'),
                type: "success"
            });
        });
    };

    sendOrder() {
        if (this.file !== false) {
            this.alerter.swal({
                title: this._translator('TEMPLATE:ORDER:SEND_ORDER_HEADER').replace(/:name/, this.file.name),
                text: this._translator('TEMPLATE:ORDER:SEND_ORDER_BODY').replace(/:name/, this.file.name),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55"
            }, (isConfirmed) => {
                if (isConfirmed) {
                    this.orderUpload(this.file, this.contactEmail);
                }
            });
        }
    };
};
